import { CommonErrorDetailsType } from '@elearning-platform/api-types/interfaces';
import { InternalAxiosRequestConfig } from 'axios';

export class FrontendApiError {
  public responseCode: number;
  public endpointUrl: string | undefined;
  public requestHasAuthorization: boolean;
  public message: string;
  public details: CommonErrorDetailsType | null;
  public config: InternalAxiosRequestConfig | undefined;

  constructor(
    message: string,
    responseCode: number,
    endpointUrl: string | undefined,
    requestHasAuthorization: boolean,
    details: CommonErrorDetailsType | null,
    config: InternalAxiosRequestConfig | undefined = undefined,
  ) {
    this.responseCode = responseCode;
    this.endpointUrl = endpointUrl;
    this.requestHasAuthorization = requestHasAuthorization;
    this.message = message;
    this.details = details;
    this.config = config;
  }
}
